import {
  REQUEST,
  RESPONSE,
  CLEAR,
  FAILURE,
} from '../../actions/forecasts/predictions';

const initialState = {
  isLoading: false,
  error: null,
  response: {
    chartData: [],
    segmentInfo: {},
    totalPoints: 0
  }
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case RESPONSE:
      return {
        ...state,
        isLoading: false,
        response: action.payload
      };
    case CLEAR:
      return initialState;
    case FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    default:
      return state;
  }
}; 